import { Component, EventEmitter, Input, Output } from '@angular/core';
import { PlatformEnum } from '@panamax/app-state';

@Component({
  selector: 'app-browse-guest-title',
  templateUrl: './browse-guest-title.component.html',
  styleUrls: ['./browse-guest-title.component.scss'],
})
export class BrowseGuestTitleComponent {
  @Input() platformType: string;
  @Output() becomeACustomerClickEmitter = new EventEmitter<void>();

  platformEnum = PlatformEnum;

  constructor() {}

  onBecomeACustomerClick() {
    this.becomeACustomerClickEmitter.emit();
  }
}
